module.exports = __webpack_public_path__ + "img/m-item04.9f30cfb.png";